import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { content } from "../data.tsx";
import Button from "../components/button/Button.tsx";
import UseAuth from "../utils/use-auth.ts";
import UseChat from "../utils/use-chat.ts";

const MobileHeader = ({ activeSection }) => {
  const [navShow, setNavShow] = useState(false);
  const { setCurrentConversation } = UseChat();
  const { user, HandleUserLogOut } = UseAuth();

  const onToggleNav = () => {
    setNavShow((status) => {
      if (status) {
        document.body.style.overflow = "auto";
      } else {
        document.body.style.overflow = "hidden";
      }
      return !status;
    });
  };

  return (
    <div className="lg:hidden">
      <button
        type="button"
        className="h-10 w-10 inline-flex items-center justify-center rounded-lg bg-gray-50 border border-gray-100 hover:bg-gray-100 transition"
        aria-label="Toggle Menu"
        onClick={onToggleNav}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="4" y1="7" x2="20" y2="7" />
          <line x1="4" y1="12" x2="20" y2="12" />
          <line x1="4" y1="17" x2="20" y2="17" />
        </svg>
      </button>
      <div
        className={`fixed top-0 left-0 z-[60] h-full w-[100vw] transform bg-white ${
          navShow ? "translate-x-[0%]" : "-translate-x-full"
        }`}
        style={{ transition: "transform 0.4s cubic-bezier(.4,0,.2,1)" }}
      >
        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-100">
          <Link to="/" onClick={onToggleNav}>
            <img className="h-10" src="/assets/images/coachai.png" alt="Logo" />
          </Link>
          <button
            type="button"
            className="h-10 w-10 inline-flex items-center justify-center rounded-lg bg-gray-50 border border-gray-100 hover:bg-gray-100 transition"
            aria-label="Toggle Menu"
            onClick={onToggleNav}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="6" y1="6" x2="18" y2="18" />
              <line x1="6" y1="18" x2="18" y2="6" />
            </svg>
          </button>
        </div>

        <nav className="flex flex-col h-[calc(100%-72px)] justify-between px-6 py-8">
          <div className="flex flex-col gap-1">
            {content?.menuItems?.map((item, index) => (
              <Link
                to={item.url}
                onClick={onToggleNav}
                className={`px-4 py-3 rounded-xl text-base font-medium transition-colors ${
                  activeSection === item.head
                    ? "text-blue bg-blue/5"
                    : "text-lightBlack hover:text-blue hover:bg-gray-50"
                }`}
                key={index}
              >
                {item.head}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-3 pb-6">
            {user?.id ? (
              <>
                <NavLink to={"/chats"} onClick={() => { setCurrentConversation(null); onToggleNav(); }}>
                  <Button children="Start Chat" variant="secondary" />
                </NavLink>
                <NavLink to={"/user-setting"} onClick={onToggleNav}>
                  <Button children="Settings" variant="secondary" />
                </NavLink>
                <Button children="Logout" variant="primary" onClick={HandleUserLogOut} />
              </>
            ) : (
              <>
                <NavLink to={"/login"} onClick={onToggleNav}>
                  <Button children="Login" variant="secondary" />
                </NavLink>
                <NavLink to={"/signup"} onClick={onToggleNav}>
                  <Button children="Sign Up" />
                </NavLink>
              </>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileHeader;
